import { PaginationInformation } from './pagination-information';

export class Result {
    public success: boolean | null;
    public message: string;

    constructor() {
        this.success = null;
        this.message = '';
    }
}
interface NoParamConstructor<T> {
    new (): T;
}

export class SingleResult<T> extends Result {
    public data: T;

    constructor(type: NoParamConstructor<T>) {
        super();
        this.data = new type();
    }
}

export class ResultList<T> extends Result {
    public data: Array<T>;
    public paginationInformation: PaginationInformation;

    constructor() {
        super();
        this.data = new Array<T>();
        this.paginationInformation = new PaginationInformation();
    }
}